'use strict';

angular.module('mediacloudApp')
    .factory('BatchService', function($resource){
        return {
            GetBatchSummary: $resource('api/batch/:id/summary', {id: '@id'}),
            AddMetadata: $resource('api/batch/:id/metadata/', {id: '@id'}),
            GetBaseFiles: $resource('api/batch/:id/files', {id: '@id'}),
            CancelBatch: $resource('api/batch/:id', {id: '@id'}, {
                erase: {
                    method: 'DELETE', params: {}, isArray: false
                }
            }),
            SendForCaptioning: $resource('api/batch/:id/caption/:send', {id: '@id', send: '@send'}),
            Publish: $resource('api/publish/batch'),
            Destination: $resource('api/destination/batch'),
            CreateBatch: $resource('api/batch')
        }
    });
